import { useEffect, useState } from 'react'

import Cards from 'react-credit-cards'
import { PatternFormat } from 'react-number-format'

import { Grid, CssBaseline, FormControl, InputLabel, MenuItem, Select, FormHelperText } from '@mui/material'

import { documentTypes } from '../options'

import InputControlled from 'components/Controllers/Input'
import AutocompleteControlled from 'components/Controllers/Autocomplete'
// import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core'
import { Controller } from 'react-hook-form'

import { useTranslation } from 'react-i18next'

const CardForm = (props) => {
  const { control, watch } = props

  const [focused, setFocused] = useState('')

  const { t } = useTranslation()

  useEffect(() => {
    if (!watch('card_cvv')) return

    setFocused('cvc')
  }, [watch('card_cvv')])

  return (
    <Grid container spacing={2} direction={{ md: 'row-reverse' }} alignItems="center">
      <Grid item xs={12} md={6}>
        <CssBaseline />
        <Cards
          name={(watch('customer_firstname') || '') + ' ' + (watch('customer_lastname') || '')}
          number={watch('card_number') || ''}
          expiry={watch('card_expiration_date') || ''}
          cvc={watch('card_cvv') || ''}
          focused={focused}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <InputControlled label="Nombres" name="customer_firstname" control={control} rules={{ required: true }} inputProps={{ maxLength: 30 }} />
          </Grid>
          <Grid item xs={12} md={6}>
            <InputControlled label="Apellidos" name="customer_lastname" control={control} rules={{ required: true }} inputProps={{ maxLength: 30 }} />
          </Grid>
          <Grid item xs={12} md={6}>
            <AutocompleteControlled label="Tipo" name="customer_document_type" control={control} rules={{ required: true }} options={props.docTypes} />
          </Grid>
          <Grid item xs={12} md={6}>
            <InputControlled label="N° Documento" name="customer_document_number" control={control} rules={{ required: true }} inputProps={{ maxLength: 15 }} />
          </Grid>
          <Grid item xs={12} md={12}>
            <InputControlled label={t('Card.Number')} name="card_number" control={control} rules={{ required: true }} inputProps={{ format: '#### #### #### ####' }} InputProps={{ inputComponent: PatternFormat }} />
          </Grid>
          <Grid item xs={6} md={9}>
            <InputControlled label="F. Vencimiento" name="card_expiration_date" control={control} rules={{ required: true }} inputProps={{ format: '##/##' }} InputProps={{ inputComponent: PatternFormat }} />
          </Grid>
          <Grid item xs={6} md={3}>
            <InputControlled label="CVV" type='number' name="card_cvv" control={control} rules={{ required: true }} inputProps={{ maxLength: 4 }} onBlur={() => setFocused('name')} />
          </Grid>
          <Grid item xs={12}>
            <Controller
              rules={{ required: true }}
              control={control}
              name={"installments"}
              render={({ field }) => (
                <FormControl fullWidth>
                  <InputLabel>{"Número de cuotas"}</InputLabel>
                  <Select
                    MenuProps={{style: { height: 250 }}}
                    {...field}
                    fullWidth
                    defaultValue={"1"}
                    variant="standard"
                    placeholder="Número de cuotas"
                    onChange={(e) => field.onChange(e.target.value)}
                  >
                    {[...Array.from({ length: 36 }, (_, i) => i + 1)].map(item => 
                      <MenuItem key={item} value={item.toString()}>{item.toString()}</MenuItem>
                    )} 
                  </Select>
                </FormControl>
              )}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default CardForm
